import React from "react";
import { Col } from "reactstrap";

//i18n
import { withTranslation } from "react-i18next";

const UsernameConversation = ({ t }) => {
  return (
    <Col xs="12">
      <h5 className="font-size-15 mt-2 text-wrap pl-0 d-flex">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="16"
          height="16"
          viewBox="0 0 16 16"
          style={{ marginRight: "10px" }}
        >
          <path
            fill="white"
            fillRule="evenodd"
            d="M8 0C3.588 0 0 3.588 0 8s3.588 8 8 8 8-3.588 8-8-3.588-8-8-8zm0 1.067c3.835 0 6.933 3.098 6.933 6.933S11.835 14.933 8 14.933 1.067 11.835 1.067 8 4.165 1.067 8 1.067zM7.639 3.01c-.142.002-.279.06-.378.162-.098.103-.153.24-.15.383v4.8c0 .294.239.533.533.533h4.8c.144.002.281-.054.382-.154.102-.1.16-.236.16-.38 0-.142-.058-.28-.16-.38-.101-.1-.239-.155-.382-.153H8.178V3.556c.003-.145-.053-.284-.154-.386-.102-.103-.24-.16-.385-.159z"
          />
        </svg>
        {t("Engagement history")}
      </h5>
    </Col>
  );
};

export default withTranslation()(UsernameConversation);
